module.exports = __webpack_public_path__ + "static/img/55.469289a4.gif";